import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from '../components/Layout';
import Login from '../views/auth/Login';
import Dashboard from '../views/dashboard/Dashboard';
import Usuarios from '../views/modules/Usuarios';
import Welcome from '../views/welcome';
import Clientes from '../views/modules/Clientes';
import Documentos from '../views/modules/Documentos';
import Papeleria from '../views/modules/Papeleria';
import PapeleriaVigencia from "../views/modules/PapeleriaVigencia";
import Imagenes from "../views/modules/Imagenes";
import ProtectedRoute from '../components/ProtectedRoute';
import LandingPage from "../views/LandingPage"; // Importar el componente LandingPage
import Productos from "../views/modules/Productos"
import FloatingWhatsApp from "../components/FloatingWhatsAppButton";
import RegistrarTenencias from "../views/modules/RegistrarTenencias";
import ImprimirTenencias from "../views/modules/ImprimirTenencias";


const AppRoutes = () => {
  // Definimos las rutas protegidas en un array para evitar repetición
  const protectedRoutes = [
    { path: '/dashboard', component: <Dashboard /> },
    { path: '/usuarios', component: <Usuarios /> },
    { path: '/clientes', component: <Clientes /> },
    { path: '/documentos', component: <Documentos /> },
    { path: '/papeleria', component: <Papeleria /> },
    { path: '/papeleriaVigencia', component: <PapeleriaVigencia /> },
    { path: '/imagenes', component: <Imagenes /> },
    { path: '/welcome', component: <Welcome /> },
    { path: '/registrarTenencias', component: <RegistrarTenencias /> },
    { path: '/imprimirTenencias', component: <ImprimirTenencias /> },

  ];

  return (
    <Router>
      <Routes>
        {/* Ruta de Landing Page */}
        <Route path="/" element={<LandingPage />} />

        {/* Ruta de login */}
        <Route path="/login" element={<Login />} />
          {/* Ruta de Productos */}
          <Route path="/productos" element={<Productos />} />

        {/* Rutas protegidas */}
        {protectedRoutes.map(({ path, component }, index) => (
          <Route
            key={index}
            path={path}
            element={
              <ProtectedRoute>
                <Layout>{component}</Layout>
              </ProtectedRoute>
            }
          />
        ))}
      </Routes>
      {/* Botón flotante de WhatsApp */}
      <FloatingWhatsApp />
      
    </Router>
  );
};

export default AppRoutes;
